/*@ngInject*/
const ProposalActionRepository = function (baseRepository, currentSubmissionModel) {

    angular.extend(this, baseRepository);

    this.addSection = function (proposalId, sectionTemplateId, type) {
        var url = '/rest/Proposal/' + proposalId + '/addSection',
            config = {
                params: {
                    sectionTemplateIds: sectionTemplateId,
                    sectionType: type,
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.modifyProposal = function (proposalId) {
        const url = '/rest/Proposal/' + proposalId + '/ModifyProposal';

        return this.post(url);
    };

    this.addSectionFromDocument = function (proposalId, attachmentId, displayLabel, sectionType) {
        var url = '/rest/Proposal/' + proposalId + '/addSectionFromDocument',
            config = {
                params: {
                    attachmentId: attachmentId,
                    displayLabel: displayLabel
                }
            };

        if (sectionType) {
            config.params.sectionType = sectionType;
        }
        return this.post(url, {}, config);
    };

    this.beginBinding = function (proposalId, quoteIds) {

        var url = '/rest/Proposal/beginBinding?',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.bindProposal = function (proposalId, quoteIds) {

        var url = '/rest/Proposal/' + proposalId + '/bind?',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.copyProposal = function (proposalId, quoteList) {
        var url = '/rest/Proposal/' + proposalId + '/copy?';

        _.each(quoteList, function (quoteId, index) {
            var prepend = index === 0 ? '' : '&';
            url += prepend + 'quoteId=' + quoteId;
        });

        return this.post(url);
    };

    this.createQuote = function (submissionId, proposalId, productTemplateId) {
        var url = '/rest/Proposal/' + proposalId + '/createQuote',
            config = {
                params: {
                    submissionId: submissionId,
                    productTemplateId: productTemplateId,
                    proposalOrdinalNumber: -1
                }
            };

        return this.post(url, {}, config);
    };

    this.deleteProposal = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId + '/delete';

        return this.delete(url);
    };

    this.deleteSection = function (sectionTemplateId, invalidateProposalDocument) {
        var url = '/rest/ProposalSection/' + sectionTemplateId + '/deleteSection',
            config = {
                params: {
                    invalidateProposalDocument: invalidateProposalDocument
                }
            };

        return this.delete(url, config);
    };

    this.generateQuotes = function (proposalId) {
        const url = '/rest/Proposal/' + proposalId + '/generateQuotes';
        return this.post(url);
    };

    this.generateBinder = function (proposalId) {
        const url = '/rest/Proposal/' + proposalId + '/generateBinder';
        return this.post(url);
    };

    this.requestBinding = function (quoteIds) {
        var url = '/rest/Proposal/requestBindingByQuotes?',
            config = {
                params: {
                    quoteIds: quoteIds
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        return this.post(url, {}, config);
    };

    this.requestBindingByProposalId = function (proposalId) {
        var url = '/rest/Proposal/' + proposalId + '/requestBinding';

        return this.post(url);
    };

    this.createProposal = function (submissionId, productTemplateIds) {
        var templateIds = '';
        angular.forEach(productTemplateIds, function (productTemplateId) {
            var str = templateIds !== '' ? '&' : '';
            templateIds += str + 'productTemplateId=' + productTemplateId;
        });
        var url = '/rest/Submission/' + submissionId + '/createProposal?' + templateIds;

        return this.post(url);
    };

    this.uploadSectionFromFile = function (proposalId, data, file) {
        var url = '/rest/Proposal/' + proposalId + '/uploadSectionFromFile',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                },
                params: {
                    displayLabel: data.description,
                    filename: data.name,
                    length: data.fileExpectedSize
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };

    this.declineToBind = function (proposalId, reason, detail) {
        var url = '/rest/Proposal/' + proposalId + '/declineToBind',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.declineToBindFromSent = function (quoteIds, reason, detail) {
        var url = '/rest/Proposal/declineToBind',
            config = {
                params: {
                    quoteIds: quoteIds,
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('proposalActionRepository', ProposalActionRepository);
